import React from 'react';

/* A function that is being exported. */
export const SendMensajes = ({TextMensaje, addMensaje, onInputChange, handleKeypress}) => {
	/* Returning a div with a input and a div with a svg. */
	return (
		<div className='enviarMensajes'>
			<input
				className='inputSendMensaje'
				type='text'
				Id='inputTipoServicio'
				name='username'
				value={TextMensaje}
				onChange={(event) => onInputChange(event)}
				onKeyUp={(event) => handleKeypress(event)}
			/>
			<div
				onClick={addMensaje}
				className='buttonEnviarMensajes centrador'
			>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='20'
					height='20'
					fill='currentColor'
					className='bi bi-send-fill'
					viewBox='0 0 16 16'
				>
					<path d='M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z' />
				</svg>
			</div>
		</div>
	);
};
